import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirebaseDatabase } from '../firebase/authHandler';
import { ref, get } from 'firebase/database';
import { CURRENT_LEGAL_VERSION } from '../constants/legalDocuments';
import ConsentPage from '../pages/ConsentPage';
import { Box, CircularProgress } from '@mui/material';

export default function RequireConsent({ children, role }) {
  const [loading, setLoading] = useState(true);
  const [hasConsented, setHasConsented] = useState(false);
  const auth = getAuth();
  
  useEffect(() => {
    const checkConsent = async () => {
      const user = auth.currentUser;
      if (!user) {
        setLoading(false);
        return;
      }

      const db = getFirebaseDatabase();
      try {
        let snapshot;
        if (role === 'financier') {
          snapshot = await get(ref(db, `users/${user.uid}/preferences/legal/legalAcceptedVersion`));
        } else if (role === 'customer') {
          const phone = user.phoneNumber;
          snapshot = await get(ref(db, `global_customers/${phone}/legal/legalAcceptedVersion`));
        }

        if (snapshot && snapshot.exists() && snapshot.val() === CURRENT_LEGAL_VERSION) {
          setHasConsented(true);
        } else {
          setHasConsented(false);
        }
      } catch (error) {
        console.error("Error checking legal consent:", error);
      }
      setLoading(false);
    };

    checkConsent();
  }, [role, auth.currentUser]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--bg-base)' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!hasConsented) {
    return <ConsentPage role={role} />;
  }

  return children;
}
